const BRANCH_KEY = 'receptionist-branch';
const BRANCH_EVENT = 'receptionist-branch-updated';
const PANEL_SCOPE_KEY = 'panel-data-scope';

export function getReceptionistBranch() {
  return sessionStorage.getItem(BRANCH_KEY) || '';
}

export function setReceptionistBranch(branchName) {
  const next = branchName || '';
  const prev = sessionStorage.getItem(BRANCH_KEY) || '';
  if (next === prev) return;

  if (!next) {
    sessionStorage.removeItem(BRANCH_KEY);
  } else {
    sessionStorage.setItem(BRANCH_KEY, next);
  }
  window.dispatchEvent(new CustomEvent(BRANCH_EVENT, { detail: { branch: next } }));
}

/** 'receptionist' | 'admin' | '' — only receptionist panel enforces branch data. */
export function setPanelDataScope(scope) {
  const next = scope === 'receptionist' || scope === 'admin' ? scope : '';
  const prev = sessionStorage.getItem(PANEL_SCOPE_KEY) || '';
  if (next === prev) return;
  if (!next) sessionStorage.removeItem(PANEL_SCOPE_KEY);
  else sessionStorage.setItem(PANEL_SCOPE_KEY, next);
}

export function getPanelDataScope() {
  return sessionStorage.getItem(PANEL_SCOPE_KEY) || '';
}

export function normalizeBranchName(name) {
  return String(name || '').trim().toLowerCase();
}

export function branchesMatch(a, b) {
  const left = normalizeBranchName(a);
  const right = normalizeBranchName(b);
  return Boolean(left && right && left === right);
}

/**
 * Active branch for receptionist panel fetches.
 * Empty when admin panel, or receptionist with no assigned branch.
 */
export function getReceptionistBranchFilter() {
  if (getPanelDataScope() !== 'receptionist') return '';
  return getReceptionistBranch().trim();
}

export function isReceptionistPanelScope() {
  return getPanelDataScope() === 'receptionist';
}

/** Cache segment so admin all-gym data and branch views never collide. */
export function branchScopeCacheSuffix() {
  if (!isReceptionistPanelScope()) return '';
  const branch = getReceptionistBranchFilter();
  return branch
    ? `:branch:${normalizeBranchName(branch)}`
    : ':receptionist:nobranch';
}

/**
 * Filter rows to the receptionist's branch when in receptionist panel.
 * Returns [] if receptionist has no branch assigned (avoids leaking other branches).
 * Members with blank/unassigned branch stay visible for this gym's receptionist.
 * Admin/owner calls are unchanged.
 */
export function filterByReceptionistBranch(rows, getBranch) {
  if (!isReceptionistPanelScope()) return rows || [];
  const branch = getReceptionistBranchFilter();
  if (!branch) return [];
  const list = rows || [];
  return list.filter((row) => {
    const rowBranch = typeof getBranch === 'function' ? getBranch(row) : row?.branch;
    const normalized = normalizeBranchName(rowBranch);
    // No branch set on the record → still show (same gym already scoped by gym_id)
    if (!normalized) return true;
    return branchesMatch(rowBranch, branch);
  });
}

export const RECEPTIONIST_BRANCH_EVENT = BRANCH_EVENT;
